import { render } from "./TansakuYusha.vue?vue&type=template&id=89976d60"
import script from "./TansakuYusha.vue?vue&type=script&lang=js"
export * from "./TansakuYusha.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__